import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Card, Text } from 'react-native-paper';
import { colors, spacing, typography } from '../../../constants/theme';
import { AdminSharingLink, ReviewTemplate } from '../AdminDashboard.types';

interface AdminSharingLinksSectionProps {
  links: AdminSharingLink[];
  templates: ReviewTemplate[];
  onUnlinkItems: (linkId: number) => void;
}

export const AdminSharingLinksSection: React.FC<AdminSharingLinksSectionProps> = ({
  links,
  templates,
  onUnlinkItems,
}) => (
  <>
    <View style={styles.sectionHeader}>
      <Text style={styles.sectionTitle}>Shared Items ({links?.length || 0})</Text>
    </View>

    {links && links.length > 0 ? (
      links.map(link => {
        const sourceItem = link.sourceItem;
        const targetItem = link.targetItem;
        const sourceTemplate = templates.find(t => t.id === sourceItem?.category?.templateId);
        const targetTemplate = templates.find(t => t.id === targetItem?.category?.templateId);

        return (
          <Card key={link.id} testID={`admin-sharing-link-${link.id}`} style={styles.itemCard}>
            <Card.Content>
              <View style={styles.linkHeader}>
                <Text style={styles.linkTitle}>
                  {sourceItem?.name} → {targetItem?.name}
                </Text>
              </View>

              <View style={styles.linkDetails}>
                <Text style={styles.linkDetail}>
                  Source: {sourceTemplate?.name || 'Unknown'} / {sourceItem?.category?.name}
                </Text>
                <Text style={styles.linkDetail}>
                  Target: {targetTemplate?.name || 'Unknown'} / {targetItem?.category?.name}
                </Text>
                <Text style={styles.linkDetail}>
                  Questions mapped: {link.mappings?.length || 0}
                </Text>

                <View style={styles.linkFlags}>
                  <Text style={styles.linkFlag}>
                    {link.includeRoom ? '✓' : '✗'} Include room
                  </Text>
                  <Text style={styles.linkFlag}>
                    {link.includePhotos ? '✓' : '✗'} Include photos
                  </Text>
                </View>
              </View>

              <View style={styles.itemActions}>
                <Button
                  testID={`admin-unlink-item-${link.id}`}
                  mode="outlined"
                  onPress={() => onUnlinkItems(link.id)}
                >
                  Unlink
                </Button>
              </View>
            </Card.Content>
          </Card>
        );
      })
    ) : (
      <Text style={styles.stat}>No shared items found for this template</Text>
    )}
  </>
);

const styles = StyleSheet.create({
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing.md,
  },
  sectionTitle: {
    ...typography.h2,
    marginBottom: spacing.md,
  },
  itemCard: {
    marginBottom: spacing.md,
    borderWidth: 1,
    borderColor: colors.gray300,
  },
  itemActions: {
    flexDirection: 'row',
    gap: spacing.sm,
  },
  stat: {
    ...typography.caption,
    color: colors.textSecondary,
  },
  linkHeader: {
    marginBottom: spacing.sm,
  },
  linkTitle: {
    ...typography.h3,
    fontSize: 16,
    fontWeight: 'bold',
  },
  linkDetails: {
    marginTop: spacing.sm,
  },
  linkDetail: {
    ...typography.body2,
    color: colors.textSecondary,
    marginBottom: spacing.xs,
  },
  linkFlags: {
    flexDirection: 'row',
    gap: spacing.md,
    marginTop: spacing.sm,
  },
  linkFlag: {
    ...typography.caption,
    color: colors.textSecondary,
  },
});

export default AdminSharingLinksSection;
